<app-layout>
  <div class="chat-page">
    <app-chat-bot variant="page"></app-chat-bot>
  </div>
</app-layout>
